import { graphql, useStaticQuery } from 'gatsby';

const useCTAMetadata = () => {
  const { callToAction } = useStaticQuery(graphql`
            query {
              callToAction: contentfulCallToActions(id: {eq: "e594fc02-48e0-5205-a8da-5400e8367fbe"}) {
                title
                description
                primaryCtaText
                primaryCtaLink
                secondaryCtaText
                secondaryCtaLink
              }
            }
            `
  );
  return callToAction;
};

export default useCTAMetadata;